<template>
    <div class="rhythmClass">
        <el-col :span="24" class="imgStyle godImg" align="left" v-if="heart.questionDto.detailInfo.zipUrl">
            <div class="fileBice" :style="{width:heart.questionDto.detailInfo.imgUrl&&heart.questionDto.detailInfo.imgUrl.split(',').length ==1? '50%':''}">
                <div class="bodyclass centerOne" title="点击下载ZIP包">
                   <button class="downZip" @click="loadUrl(heart.questionDto.detailInfo.zipUrl)"><img src="../../../static/images/updataFile-button.png" alt=""> 下载素材</button>
                   <span>
                        请点击下载ZIP
                        <em style="font-size:16px;">(文件大小：{{downLoadFileSize}})</em>
                    </span>
                </div>
            </div>
        </el-col>
        <el-col :span="24" :class="['imgStyle','godUpload', heart.questionDto.detailInfo.zipUrl? '':'fullClass']" align="left">
            <div class="gudClass">
                <div class="operation-tag">
                    <p class="bse">注：支持<b>{{`${heart.fileSize}Mb`}}</b>以内的文件上传</p>
                    <span>/ 可上传总数：{{heart.fileNum||1}}个 </span>
                    <!-- <span>/ 点击查看支持<b @click="dialogCanUpList = true">文件类型</b> </span> -->
                </div>
                <div class="uploadBodys">
                    <!-- <p class="uploadBodys_names"><b>复制我的压缩名称：</b>
                        <span slot="reference" class="tag-read" :data-clipboard-text="`${upFileName120}_${serial}.zip`"> <span class="shouMaxes">{{upFileName120}}_{{serial}}.zip</span> <el-button @click="clickCopy" class="copyBtuStyle" style="padding: 5px 9px;" size="mini">复制</el-button> </span>
                    </p> -->
                    <div class="operation-save" v-for="(child,childIndex) in docMitObj" v-if="child.isShow" :key="child.uuid">
                        <!-- <div class="baseUp">已上传</div> -->
                        <up-doc ref="upDoc"
                            :class="['upShiping']"
                            :style="{
                                pointerEvents:(!(submitNum>0||submitNum==-1)? 'none':'auto')
                            }"
                            :styleEd="'\
                                width: 150px;\
                                font-size: 15.5px;\
                                background-color: rgb(0, 204, 106);\
                                color: #fff;border-radius: 5px;\
                                border: 1px solid #01CB69;\
                                pointer-events: auto;'"
                            @upImgUrl="upImgUrl($event)"
                            @deleteNullItem="deleteNullItem($event)"
                            :text="uploadFile"
                            :networkError="networkError"
                            :TYPE="upTypeList.map((cur)=> cur.content).join()"
                            :limitSize="limitSize"
                            :serial="serial"
                            :serialUuid='child.uuid'
                            :fileOssUrl="child.url"
                            key="child.uuid" 
                            >
                            <template slot="kdelete">
                                <el-button size="mini" v-if="childIndex!=0" @click="deleteNullItem({'serialUuid':child.uuid})" class="noUploading" type="danger">删除</el-button>
                            </template>
                        </up-doc>
                    </div>
                    <el-button type="success"
                        @click="addOneUpload"
                        v-if="isAddBtu"
                        icon="el-icon-plus"
                        size="small"
                        style="margin-top: 7px;"
                    >新增文件上传</el-button>
                    <!-- <p class="operation-num">剩余上传次数：{{submitNum==-1? '不限次':submitNum}}</p>
                     -->
                </div>
            </div>
        </el-col>
        <!-- 支持文件类型 -->
        <el-dialog
            title="提示"
            class="canUpListBox"
            :visible.sync="dialogCanUpList"
            width="30%"
            append-to-body
            :close-on-click-modal="false"
            :show-close="false"
            center>
                <div class="canUp-con">
                    <p>支持文件格式包含如下，请自行转换格式（小写）后上传：</p>
                    <p class="suoj2" v-for="filety in upTypeList" :key="filety.name">
                        {{filety.name}}：
                        {{filety.content.replace(/,/g,"、").replace(/image\/|application\//g,".")}}
                    </p>
                    <div class="canUp-fooder">
                        <el-button @click="dialogCanUpList = false" size="medium"> 关 闭 </el-button>
                    </div>
                </div>
        </el-dialog>
    </div>
</template>
<script>
import upDoc from '../../components/upDoc'
import utils from '../../lib/util'
import wsMethod from '../../lib/socketMethod'
    export default {
        name:"creativeTopic",
        props: {
            sonData: Object,
            allAnswer:Object,
            networkError:Boolean,
            upFileName120:String,
            serial:Number,
        },
        data() {
            return {
                heart:{
                    questionDto:{
                        detailInfo:{}
                    }
                },
                uploadFile:'上传材料',
                limitSize:'204800',//kb
                submitNum:0,
                designUrl:'',
                downLoadFileSize:0,
                answerType:null,
                //可上传文件数量 及内容
                docMitObj:[],
                upTypeList:[],
                dialogCanUpList:false,
            }
        },
        components:{
            upDoc
        },
        watch: {
            'designUrl':function(now,old){
                if(now&&this.answerType)this.answerType = null
                this.$emit('storeLocally')
            },
            'answerType':function(now,old){
                this.$emit('storeLocally')
            },
        },
        computed:{
            rNGet: function () {
                return localStorage.getItem('roadName')?localStorage.getItem('roadName'):'guoyin'
            },
            isAddBtu(){
                return this.listShowNumber().num != this.heart.fileNum
            }
        },
        created(){},
        mounted(){
            this.heart = this.sonData
            this.heart.fileSize = this.heart.fileSize? this.heart.fileSize:200
            this.limitSize = String(this.heart.fileSize * 1024)
            this.submitNum = utils.mottoClone(this.heart.submitNum)
            let zipUrl = this.heart.questionDto.detailInfo.zipUrl
            this.downLoadFileSize = utils.getFileSize(zipUrl.split('/')[zipUrl.split('/').length - 1].substring(26,zipUrl.split('/')[zipUrl.split('/').length - 1].length-4))
            if(!this.heart.fileNum) this.heart.fileNum = 1//空默认1
            this.uploadFile = this.veinQuest[this.rNGet].problem.uploadBtu120
            let currentDocArr = []
            for (let i = 1; i <= this.heart.fileNum; i++) {
                currentDocArr.push({
                    uuid:this.serial+'_'+i+'_'+utils.uuid2(16),//第几题_第几空_16位标识
                    index:i,
                    isShow:false,
                    url:'',
                })
            }
            this.$nextTick(function(){
                if(this.allAnswer){
                    if(this.allAnswer.obj.designUrl){
                        let desArr = this.allAnswer.obj.designUrl.split(',')
                        desArr.forEach((element,ci) => {
                            currentDocArr[ci].url = element?element:''
                            currentDocArr[ci].isShow = element?true:false
                        });
                        let currentMitArr = Array.from(currentDocArr,({url})=>url)
                        this.designUrl = currentMitArr.findIndex((cur)=>cur)>=0? currentMitArr.join():''
                    }
                    this.answerType = this.allAnswer.obj.answerType
                }
                if(this.listShowNumber(currentDocArr).num<=0)
                currentDocArr[0].isShow = true //至少开启一个
            
                this.docMitObj = currentDocArr
                this.upTypeList = []
                let typeObj = this.veinQuest[this.rNGet].problem.allowHook
                for (const key in typeObj) {
                    this.upTypeList.push({
                        name:{'img':'图片','video':'视频','audio':'音频','doc':'文件'}[key],
                        content:typeObj[key]
                    })
                }
            })
        },
        methods:{
            upImgUrl(sObj){//{serialUuid,url}
                let plays = this.submitNum
                let nPlays = this.heart.submitNum
                if(plays>0||nPlays==-1){
                    let i = this.docMitObj.findIndex((item)=>item.uuid==sObj.serialUuid)
                    this.docMitObj[i].url = sObj.url
                    this.$refs.upDoc.url = ''
                    // if(this.submitNum<=0) this.submitNum==-1? this.submitNum=-1:this.submitNum=0
                    // else this.submitNum--;

                    if(!sObj.url) this.deleteNullItem(sObj,1)
                    else this.listSort()
                    let currentMitArr = Array.from(this.docMitObj,({url})=>url)
                    this.designUrl = currentMitArr.findIndex((cur)=>cur)>=0? currentMitArr.join():''
                    this.$nextTick(()=>{
                        wsMethod.wsSend210(this.heart.bId,this.heart.questionId,{
                            allData:this.$parent.allData,
                            uuid1:this.$parent.uuid1,
                            firstStartDateVal:this.$parent.firstStartDateVal,
                        })
                    })
                }else{
                    this.$message({showClose: true,message: `只能上传${nPlays}次`})
                }
            },
            loadUrl(url){
                if(!url) return
                this.$store.commit('get_isSwitch',true)
                var a = document.createElement('a');
                a.setAttribute('href', url);
                a.setAttribute('target', '_blank');
                a.setAttribute('id', 'startTelMedicine');
                // 防止反复添加
                if(document.getElementById('startTelMedicine')) {
                    document.body.removeChild(document.getElementById('startTelMedicine'));
                }
                document.body.appendChild(a);
                a.click();
            },
            clickCopy() { 
                var clipboard = new this.Clipboard('.tag-read');  
                clipboard.on('success', e => {  
                    this.$notify({
                        title: '复制成功',
                        type: 'success'
                    });
                    // 释放内存  
                    clipboard.destroy()  
                })  
                clipboard.on('error', e => {  
                    // 不支持复制
                    this.$notify({
                        title: '该浏览器不支持自动复制',
                        type: 'success'
                    }); 
                    // 释放内存  
                    clipboard.destroy()  
                })  
            },
            changeAnswerType(val){
                this.answerType = val.answerType
            },
            // 统计 显示/是否有url
            listShowNumber(obj=this.docMitObj){
                const isS = obj.filter((son)=>son.isShow)
                const uploadiingFile = Object.keys(this.$store.state.isZip.zipLoading).map((son)=>son.replace('doc_',''))
                const isU = isS.filter((son)=>!son.url&&!uploadiingFile.includes(son.uuid))
                return {
                    num:isS.length, //显示数
                    haveUrl:isU.length //是否都含有url
                }
            },
            // 新增
            addOneUpload(){
                const i = this.docMitObj.findIndex((son)=>!son.isShow)
                if(i < 0){
                    this.$message({
                        message: `最大可上传数量已满！`,
                        showClose: true,
                        type: 'error'
                    })
                    return
                }
                // 显示上传项目都上传后才可新增
                const isNotUrl = this.listShowNumber()
                if(isNotUrl.haveUrl >= 1){
                    this.$message({
                        message: `含有未上传的条目，请先上传！`,
                        showClose: true,
                        type: 'error'
                    })
                    return
                }
                
                this.docMitObj[i].isShow = true
            },
            // 删除（隐藏）
            deleteNullItem(sObj,firstDeleteUrl=''){
                if(this.networkError) {this.$message.error('当前网络不佳,请您稍后重试！');return}
                let i = this.docMitObj.findIndex((item)=>item.uuid==sObj.serialUuid)
                if(i==0 && this.listShowNumber().num==1 && !firstDeleteUrl){
                    // this.$message({
                    //     message: `文件未上传，请先上传文件`,
                    //     showClose: true,
                    //     type: 'error'
                    // })
                    return
                }
                this.docMitObj[i].isShow = false
                this.docMitObj[i].url = ''
                this.listSort()
            },
            /**
             * docMitObj重新排：
             *  有url（含正在上传）：排前面，不变
             *  没url：按index顺序
            */
            listSort(){
                const uploadiingFile = Object.keys(this.$store.state.isZip.zipLoading).map((son)=>son.replace('doc_',''))
                let yesUrl = [],noUrl = [];
                for (let i = 0; i < this.docMitObj.length; i++) {
                    if(
                        this.docMitObj[i].url ||
                        uploadiingFile.includes(this.docMitObj[i].uuid) )
                    {
                        yesUrl.push(this.docMitObj[i])
                    }else{
                        noUrl.push(this.docMitObj[i])
                    }
                }
                //没url  按index排序
                noUrl.sort(function(a, b) {
                    return a.index - b.index
                });
                if(noUrl.length == this.docMitObj.length){
                    noUrl = noUrl.map((child,ic)=>{
                        if(ic==0)child.isShow = true
                        else child.isShow = false
                        return child
                    })
                }
                
                this.docMitObj = [...yesUrl,...noUrl]
            }
        }
    }
</script>
<style scoped lang="less">
    .rhythmClass{
        height: 100%;
        width: 100%;
        position: relative;
        .godImg{
            position: absolute;
            top: 3px;
            left: 0;
            right: 0;
            height: 55px;
            width: 100%;
        }
        .godUpload{
            position: absolute;
            top: 72px;
            bottom: 0;
            right: 0;
            width: 100%;
        }
        .fullClass{top: 10px !important;}
        .imgStyle{
            .fileBice{
                height: 100%;
                width: 80%;
                background: #FFFFFF;
                box-sizing: border-box;
                margin: auto;
                .bodyclass{
                    position: absolute;
                    // bottom: 15%;
                    top: 50%;
                    left: 0;
                    right: 0;
                    margin: 0 auto;
                    transform: translate(0,-50%);
                    height: 100%;
                    width: 100%;
                    // min-height:140px;
                    // max-height:150px;
                    .downZip{
                        width: 170px;
                        height: 38px;
                        font-size: 17px;
                        background-color: #F6B400;
                        color: #fff;
                        border-radius: 5px;
                        border: 3px solid#F6B400;
                        cursor: pointer;
                        img{
                            vertical-align: bottom;
                        }
                    }
                }
                .centerOne{
                    border: 1px solid #c0ccda;
                    border-radius: 5px;
                    display: flex;
                    justify-content: left;
                    align-items: center;
                    box-sizing: border-box;
                    padding-left: 25px;
                    span{
                        display: inline-block;
                        font-weight: bold;
                        font-size: 17px;
                        margin-left: 10px;
                    }
                }
            }
            // 上传文件
            .gudClass{
                height: 100%;
                width: calc( 100% - 2px );
                position: relative;
                border: 1px solid #c0ccda;
                border-radius: 5px;
                box-sizing: border-box;
                .operation-tag{
                    width: 100%;
                    height: 35px;
                    line-height: 35px;
                    box-sizing: border-box;
                    padding: 2px 0 0 25px;
                    color: red;
                    font-size: 15px;
                    border-radius: 8px;
                    .bse{
                        display: inline-block;
                        animation: tipRedflicker 1.5s linear infinite;
                        -o-animation: tipRedflicker 1.5s linear infinite;
                        -moz-animation: tipRedflicker 1.5s linear infinite;
                        -webkit-animation: tipRedflicker 1.5s linear infinite;
                    }
                    span{
                        color: #1D80FE;
                        margin-left: 1px;
                        b{
                            cursor: pointer;
                            margin-left: 2px;
                            // text-decoration: underline;
                            border-bottom: 1px solid #1D80FE;
                        }
                    }
                }
                .uploadBodys{
                    width: 100%;
                    height: calc( 100% - 37px );
                    padding: 1px 25px 3px 25px;
                    box-sizing: border-box;
                    overflow-x: hidden;
                    overflow-y: auto;
                    .uploadBodys_names{
                        font-size: 15px;
                        margin-bottom: 5px;
                        margin-top: 5px;
                        .shouMaxes{
                            height: 24px;
                            line-height: 23px;
                            display: inline-block;
                            max-width: 420px;
                            color: #2F89FF;
                            overflow: hidden;
                            text-overflow:ellipsis;
                            white-space: nowrap;
                            vertical-align: middle;
                        }
                        .copyBtuStyle{
                            color: #fff;
                            width: 50px;
                            border: none !important;
                            animation: btn6Ani 1.3s ease-out infinite;
                            -webkit-animation:btn6Ani 1.3s ease-out infinite;
                        }
                    }
                    .operation-save{
                        width: 100%;
                        margin: 3px 0;
                        display: inline-block;
                        border-bottom: 1px dashed #ccc;
                        box-sizing: border-box;
                        padding-bottom: 5px;
                        margin-top: 10px;
                        .baseUp{
                            float: left;
                            width: 105px;
                            height: 32px;
                            font-size: 16px;
                            margin-top: 3px;
                            margin-left: 120px;
                            margin-right: 20px;
                            line-height: 32px;
                            text-align: right;
                            box-sizing: border-box;
                            background-image: url('../../../static/images/dui.png');
                            background-repeat: no-repeat;
                            background-size: 19% auto;
                            background-position: 34% 50%;
                        }
                        .upShiping{
                            width: 100%;
                            box-sizing: border-box;
                        }
                    }
                    .operation-save::after{
                        content: '';
                        height: 0;
                        display: block;
                        overflow: hidden;
                        clear: both;
                    }
                    .operation-num{
                        font-size: 13px;
                        margin-top: 10px;
                        text-align: center;
                    }
                }
            }
        }   
    }
    @keyframes btn6Ani
    {
        0% {background: #1D80FE;}
        50% {background: #032B5E;}
        100% {background: #1D80FE;}
    }
     /* Safari 与 Chrome */
    @-webkit-keyframes btn6Ani
    {
        0% {background: #1D80FE;}
        50% {background: #032B5E;}
        100% {background: #1D80FE;}
    }
    /* 定义动画 */
    @keyframes tipRedflicker {
        0% {
            color: red; 
        }
        50% {
            color: #4c0303;
        }
        100% {
            color: red;
        }
    }
</style>
<style>
    .upShiping .el-upload{
        width: 45% !important;
        text-align: left;
        float: left;
    }
    .canUpListBox .el-dialog{
        width: 650px !important;
        min-height: 200px;
    }
    .canUpListBox .el-dialog .el-dialog__header{
        /* display: none !important; */
        background: #1D4BB0 !important;
    }
    .canUpListBox .canUp-con p{
        font-size: 17.5px;
        box-sizing: border-box;
        padding: 7px;
        text-align: left;
    }
    .canUpListBox .canUp-con .suoj2{
        text-indent: 35px;
        padding-top: 5px;
    }
    .canUpListBox .canUp-fooder{
        text-align: center;
        margin-top: 10px;
        width: 100%;
    }
</style>


// WEBPACK FOOTER //
// src/components/exam/fileUpTopic.vue